import React, { useEffect, useState } from 'react';
import AssetsListing from './AssetsListing';
import { columnTypes } from 'src/components/UI/atoms/ATMTable/ATMTable';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/redux/store';
import { setPage, setRowsPerPage, setSearchValue ,setIsTableLoading,setItems , setTotalItems } from 'src/redux/slices/AssetsSlice';
import AddAssetsFormWrapper from '../Add/AddAssetsFormWrapper';
import { useDeleteAssetsMutation, useGetAllAssetsQuery } from 'src/services/AssetsServices';
import { RxPencil1 } from 'react-icons/rx';
import { UserModuleActionTypes, UserModuleNameTypes } from 'src/models/userAccess/UserAccess.model';
import { MdDeleteOutline } from 'react-icons/md';
import { showConfirmationDialog } from 'src/utils/showConfirmationDialog';
import { showToast } from 'src/utils/showToaster';
import ATMMenu from 'src/components/UI/atoms/ATMMenu/ATMMenu';
import EditAssetsFormWrapper from '../Edit/EditAssetsFormWrapper';
import { isCheckColumnPermission } from 'src/helpers/userAccessFun';

type Props = {};

const AssetsListingWrapper = (props: Props) => {
  const dispatch = useDispatch();
  const { items, totalItems, page, rowsPerPage, searchValue, isTableLoading } =
    useSelector((state: RootState) => state.assets);  

    const [deleteAssets] = useDeleteAssetsMutation()
    
    const [isOpenAddForm , setIsOpenAddForm] = useState(false) 
  const [isOpenEditForm, setIsOpenEditForm] = useState(false);
  const [selectedId, setSelectedId] = useState(""); 

  const {data , isLoading , isFetching} = useGetAllAssetsQuery( {
    limit: rowsPerPage,
    searchValue: searchValue,
    params: ["assetName"],
    page: page,
    filterBy: [],
    dateFilter: {},
    orderBy: "createdAt",
    orderByValue: -1,
    isPaginationRequired: true,
  })  

  useEffect(() => {
    if (isLoading || isFetching) {
      dispatch(setIsTableLoading(true));
    } else {
      dispatch(setItems(data?.data || []));
      dispatch(setTotalItems(data?.totalItem || 0));
      dispatch(setIsTableLoading(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isLoading, isFetching]);

  const getActionOptions = (assetsId: string) => {
    return [
      {
        label: (
          <div className="flex items-center gap-2 text-secondary-main">
            <RxPencil1 className="text-lg" /> Edit
          </div>
        ),
        onClick: () => {
          setSelectedId(assetsId);
          setIsOpenEditForm(true);
        },
        actionName: UserModuleActionTypes.EDIT,
        moduleName: UserModuleNameTypes.ASSETS,
      },
      {
        label: (
          <div className="flex items-center gap-2 font-semibold text-red-600">
            <MdDeleteOutline className="text-lg" /> Delete
          </div>
        ),
        onClick: () => {
          showConfirmationDialog({
            title: "Heads Up",
            text: "Are you sure want to Delete this Assets ?",
            icon: "question",
            showCancelButton: true,
            next: (result) => {
              if (result?.isConfirmed) {
                deleteAssets({ id: assetsId }).then((res: any) => {
                  if (res?.error) {
                    showToast("error", res?.error?.data?.message);
                  } else {
                    if (res?.data?.status) {
                      showToast("success", res?.data?.message);
                    } else {
                      showToast("error", res?.data?.message);
                    }
                  }
                });
              }
            },
          });
        },
        actionName: UserModuleActionTypes.DELETE,
        moduleName: UserModuleNameTypes.ASSETS,
      },
    ];
  };

  const columns: columnTypes[] = [
    { field: 'assetName', headerName: 'Assets Name', flex: 'flex-[1_1_0%]' },
    {
        field: "action",
        headerName: "",
        flex: "flex-[1_1_0%]",
        extraClasses: " py-2",
        renderCell: (row: any) => {
          const options = getActionOptions(row?._id);
          return <ATMMenu options={options} orientation="vertical" />;
        },
      },
  ];

  return (
    <div>
      <AssetsListing
        columns={ isCheckColumnPermission({
          moduleName: UserModuleNameTypes.ASSETS,
          actionName: UserModuleActionTypes.LIST,
          columns: columns,
        })} 
        onAddNew ={()=>{setIsOpenAddForm(true)}}
        rows={items}
        paginationProps={{
          isTableLoading,
          totalItems,
          page,
          rowsPerPage,
          searchValue,
          setPage: (newPage) => dispatch(setPage(newPage)),
          setRowsPerPage: (newRowsPerPage) => dispatch(setRowsPerPage(newRowsPerPage)),
          setSearchValue: (newValue) => dispatch(setSearchValue(newValue)),
        }}
      />
      {isOpenAddForm && <AddAssetsFormWrapper onClose={()=>{setIsOpenAddForm(false)}} />}
      {isOpenEditForm && <EditAssetsFormWrapper selectedId={selectedId}  onClose={()=>{setIsOpenEditForm(false)}}/>}
    </div>
 
  );
};

export default AssetsListingWrapper;